<div class="field-execution-container">

  <!-- 1. HEADER -->
  <header class="fe-header">
    <div class="fe-header-content">
      <div class="header-left">
        <div class="header-branding">
          <div class="helmet-icon-wrap">
            <i class="fa-solid fa-hard-hat"></i>
          </div>
          <div class="title-meta">
            <h1>Field Execution</h1>
            <p>MANAGE BLOCKS AND PROJECT EXECUTION</p>
          </div>
        </div>
      </div>

      <div class="header-actions">
        <button (click)="goHome()" class="action-btn-outline home-btn" title="Back to Home">
          <i class="fa-solid fa-house"></i>
          <span>Home</span>
        </button>
        <button (click)="showImportModal.set(true)" class="action-btn-outline import">
          <i class="fa-solid fa-file-import"></i>
          <span>Import</span>
        </button>
        <button (click)="downloadTemplate()" class="action-btn-outline template">
          <i class="fa-solid fa-file-excel"></i>
          <span>Template</span>
        </button>
      </div>
    </div>
  </header>

  <!-- MOBILE: compact KPI grid (icon + value only) -->
  <div class="fe-mobile-only fe-mobile-kpi">
    <div class="fe-kpi-row">
      <button type="button" class="fe-kpi-tile blue" (click)="openList('totalBlocks')" aria-label="Total Blocks">
        <i class="fa-solid fa-city"></i>
        <span class="fe-kpi-val">{{ globalStats().totalBlocks }}</span>
      </button>
      <button type="button" class="fe-kpi-tile purple" (click)="openList('totalProjects')" aria-label="Total Projects">
        <i class="fa-solid fa-briefcase"></i>
        <span class="fe-kpi-val">{{ globalStats().totalProjects | number }}</span>
      </button>
      <button type="button" class="fe-kpi-tile green" (click)="openList('onTrack')" aria-label="On Track">
        <i class="fa-solid fa-circle-check"></i>
        <span class="fe-kpi-val">{{ globalStats().onTrack }}</span>
      </button>
      <button type="button" class="fe-kpi-tile red" (click)="openList('delayed')" aria-label="Delayed">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span class="fe-kpi-val">{{ globalStats().delayed }}</span>
      </button>
    </div>
    <div class="fe-kpi-row">
      <button type="button" class="fe-kpi-tile cyan" (click)="openList('sanctioned')" aria-label="Sanctioned Amount">
        <i class="fa-solid fa-indian-rupee-sign"></i>
        <span class="fe-kpi-val">{{ sanctionedCompact() }}</span>
      </button>
      <button type="button" class="fe-kpi-tile navy" (click)="openList('avgProgress')" aria-label="Average Progress">
        <i class="fa-solid fa-chart-line"></i>
        <span class="fe-kpi-val">{{ globalStats().avgProgress }}%</span>
      </button>
      <button type="button" class="fe-kpi-tile amber" (click)="openList('executants')" aria-label="Executants">
        <i class="fa-solid fa-user-tie"></i>
        <span class="fe-kpi-val">{{ executantStats().unique }}</span>
      </button>
      <button type="button" class="fe-kpi-tile orange" (click)="openList('inProgress')" aria-label="In Progress">
        <i class="fa-solid fa-clock"></i>
        <span class="fe-kpi-val">{{ globalStats().inProgress }}</span>
      </button>
    </div>
  </div>

  <!-- MOBILE: sticky search -->
  <div class="fe-mobile-only fe-mobile-search">
    <div class="fe-search-box">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="search"
             placeholder="Search blocks…"
             [ngModel]="searchTerm()"
             (ngModelChange)="searchTerm.set($event)"
             aria-label="Search blocks" />
      @if (searchTerm()) {
        <button type="button" class="fe-search-clear" (click)="searchTerm.set('')" aria-label="Clear search">
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>
  </div>

  <!-- 3. SUMMARY STATS CARDS (desktop) -->
  <div class="stats-cards-row fe-desktop-only">
    <div class="stat-card blue fe-link" (click)="openList('totalBlocks')">
      <div class="icon-circle"><i class="fa-solid fa-city"></i></div>
      <div class="info">
        <p class="label">Total Blocks</p>
        <h2 class="value">{{ globalStats().totalBlocks }}</h2>
      </div>
    </div>
    <div class="stat-card purple fe-link" (click)="openList('totalProjects')">
      <div class="icon-circle"><i class="fa-solid fa-briefcase"></i></div>
      <div class="info">
        <p class="label">Total Projects</p>
        <h2 class="value">{{ globalStats().totalProjects | number }}</h2>
      </div>
    </div>
    <div class="stat-card green fe-link" (click)="openList('onTrack')">
      <div class="icon-circle"><i class="fa-solid fa-circle-check"></i></div>
      <div class="info">
        <p class="label">On Track</p>
        <h2 class="value">{{ globalStats().onTrack }}
          <span class="perc">({{ globalStats().onTrackPercent }}%)</span>
        </h2>
      </div>
    </div>
    <div class="stat-card orange fe-link" (click)="openList('inProgress')">
      <div class="icon-circle"><i class="fa-solid fa-clock"></i></div>
      <div class="info">
        <p class="label">In Progress</p>
        <h2 class="value">{{ globalStats().inProgress }}
          <span class="perc">({{ globalStats().inProgressPercent }}%)</span>
        </h2>
      </div>
    </div>
    <div class="stat-card red fe-link" (click)="openList('delayed')">
      <div class="icon-circle"><i class="fa-solid fa-triangle-exclamation"></i></div>
      <div class="info">
        <p class="label">Delayed (&gt;60 Days)</p>
        <h2 class="value">{{ globalStats().delayed }}
          <span class="perc">({{ globalStats().delayedPercent }}%)</span>
        </h2>
      </div>
    </div>
    <div class="stat-card cyan fe-link" (click)="openList('sanctioned')">
      <div class="icon-circle"><i class="fa-solid fa-indian-rupee-sign"></i></div>
      <div class="info">
        <p class="label">Total Sanctioned</p>
        <h2 class="value">{{ formatCostLakh(globalStats().sanctioned) }}</h2>
      </div>
    </div>
    <div class="stat-card navy fe-link" (click)="openList('avgProgress')">
      <div class="icon-circle"><i class="fa-solid fa-chart-line"></i></div>
      <div class="info">
        <p class="label">Avg. Progress</p>
        <h2 class="value">{{ globalStats().avgProgress }}%</h2>
      </div>
    </div>
    <div class="stat-card amber fe-link" (click)="openList('executants')">
      <div class="icon-circle"><i class="fa-solid fa-user-tie"></i></div>
      <div class="info">
        <p class="label">Executants</p>
        <h2 class="value">{{ executantStats().unique }}</h2>
      </div>
    </div>
  </div>

  <!-- MOBILE: block cards -->
  <div class="fe-mobile-only fe-mobile-blocks">
    @if (isLoading()) {
      <div class="fe-mobile-loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Loading blocks…</p>
      </div>
    } @else if (filteredBlocks().length === 0) {
      <div class="fe-mobile-empty">
        <i class="fa-solid fa-filter-circle-xmark"></i>
        <p>No blocks match your search.</p>
        <button type="button" (click)="clearFilters()">Reset</button>
      </div>
    } @else {
      @for (block of filteredBlocks(); track block.block; let i = $index) {
        <article class="fe-block-card" (click)="selectBlock(block)">
          <div class="fe-block-card-top">
            <span class="fe-block-rank">#{{ i + 1 }}</span>
            <div class="fe-block-main">
              <h3 class="fe-block-name">{{ blockLabel(block.block) }}</h3>
              <p class="fe-block-sub">{{ block.totalProjects }} Projects</p>
            </div>
            @if (block.statusBadge) {
              <span [class]="statusPillClass(block.statusBadge)">{{ block.statusBadge | uppercase }}</span>
            }
            <i class="fa-solid fa-chevron-right fe-block-chevron" aria-hidden="true"></i>
          </div>
          <p class="fe-block-amount">{{ formatCostLakh(block.sanctionedAmount) }}</p>
          <div class="fe-block-progress">
            <span class="fe-block-progress-lbl">Progress</span>
            <div class="fe-block-progress-track">
              <div class="fe-block-progress-fill"
                   [style.width.%]="block.avgProgress"
                   [class.low]="block.avgProgress < 30"
                   [class.mid]="block.avgProgress >= 30 && block.avgProgress < 70"
                   [class.high]="block.avgProgress >= 70"></div>
            </div>
            <span class="fe-block-progress-pct">{{ block.avgProgress }}%</span>
          </div>
          <p class="fe-block-updated">
            Updated <span [class.today]="block.lastUpdated === 'Today'">{{ block.lastUpdated ?? '–' }}</span>
          </p>
        </article>
      }
    }
  </div>

  <!-- 4. MAIN EXECUTION TABLE (desktop) -->
  <div class="execution-table-wrapper fe-desktop-only">
    <table class="premium-execution-table">
      <thead>
        <tr>
          <th class="w-sl">#</th>
          <th>Block / NAC</th>
          <th class="text-center">Total<br>Projects</th>
          <th class="text-center">Sanctioned Amount (₹)</th>
          <th>
            <span class="chip-dot green" style="display:inline-block;margin-right:5px;"></span>
            On Track
            <span class="th-sub">(≥ 70%)</span>
          </th>
          <th>
            <span class="chip-dot orange" style="display:inline-block;margin-right:5px;"></span>
            In Progress
            <span class="th-sub">(30% – 70%)</span>
          </th>
          <th>
            <span class="chip-dot red" style="display:inline-block;margin-right:5px;"></span>
            Delayed
            <span class="th-sub">(&gt; 60 Days)</span>
          </th>
          <th class="text-center">Avg.<br>Progress</th>
          <th class="text-center">Last<br>Updated</th>
          <th class="w-action"></th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading()) {
          <tr>
            <td colspan="10">
              <div class="table-loading">
                <i class="fa-solid fa-spinner fa-spin"></i>
                <p>Loading blocks data...</p>
              </div>
            </td>
          </tr>
        } @else if (filteredBlocks().length === 0) {
          <tr>
            <td colspan="10">
              <div class="table-empty">
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <p>No blocks match your filters.</p>
                <button (click)="clearFilters()">Reset filters</button>
              </div>
            </td>
          </tr>
        } @else {
          @for (block of filteredBlocks(); track block.block; let i = $index) {
            <tr class="execution-row" (click)="selectBlock(block)">
              <td class="w-sl">
                <div class="sl-badge">{{ i + 1 }}</div>
              </td>

              <td>
                <div class="block-info-cell">
                  <div class="side-indicator" [ngClass]="sideIndicatorClass(block.statusBadge)"></div>
                  <div class="name-meta">
                    <span class="block-name">{{ blockLabel(block.block) }}</span>
                    <span class="project-subtitle">{{ block.totalProjects }} Projects</span>
                  </div>
                  @if (block.statusBadge) {
                    <span [class]="statusPillClass(block.statusBadge)">
                      {{ block.statusBadge | uppercase }}
                    </span>
                  }
                </div>
              </td>

              <td class="text-center font-bold">{{ block.totalProjects }}</td>
              <td class="text-center font-bold">{{ formatCostLakh(block.sanctionedAmount) }}</td>

              <td>
                <div class="prog-stack">
                  <span class="p-val">{{ block.onTrackCount }} ({{ block.onTrackPercent }}%)</span>
                  <div class="p-bar-track">
                    <div class="p-bar-fill green" [style.width.%]="block.onTrackPercent"></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="prog-stack">
                  <span class="p-val">{{ block.inProgressCount }} ({{ block.inProgressPercent }}%)</span>
                  <div class="p-bar-track">
                    <div class="p-bar-fill orange" [style.width.%]="block.inProgressPercent"></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="prog-stack">
                  <span class="p-val"
                        [class.text-red]="block.delayedCount > 0">
                    {{ block.delayedCount }} ({{ block.delayedPercent }}%)
                  </span>
                  <div class="p-bar-track">
                    <div class="p-bar-fill red" [style.width.%]="block.delayedPercent"></div>
                  </div>
                </div>
              </td>

              <td class="text-center">
                <div class="circular-progress-wrap">
                  <div class="circular-progress"
                       [style.--value]="block.avgProgress"
                       [ngClass]="block.avgProgress < 30 ? 'red' : block.avgProgress < 70 ? 'orange' : 'green'">
                    <span>{{ block.avgProgress }}%</span>
                  </div>
                </div>
              </td>

              <td class="text-center">
                <span class="last-updated-pill" [class.today]="block.lastUpdated === 'Today'">
                  {{ block.lastUpdated ?? '–' }}
                </span>
              </td>

              <td class="w-action">
                <button class="arrow-btn"><i class="fa-solid fa-chevron-right"></i></button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <!-- FOOTER -->
  <div class="fe-footer-alert fe-desktop-only">
    <div class="alert-content">
      <i class="fa-solid fa-circle-info"></i>
      <span>Click on any block to view Gram Panchayats (GPs) and project-level status.</span>
    </div>
  </div>

  @if (showImportModal()) {
    <app-import-modal (closed)="onImportClosed($event)"></app-import-modal>
  }

  <!-- DYNAMIC LIST MODAL -->
  @if (listFilter()) {
    <div class="fe-modal-overlay" (click)="closeList()">
      <div class="fe-modal-card" (click)="$event.stopPropagation()">
        <div class="fe-modal-header">
          <div>
            <h3>{{ listTitle() }}</h3>
            <p>{{ listShowsBlocks() ? listBlocks().length + ' block(s)' : listProjects().length + ' project(s)' }}</p>
          </div>
          <button class="fe-modal-close" (click)="closeList()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- Executant search bar — shown only for executants modal -->
        @if (listShowsExecutants()) {
          <div class="fe-modal-search">
            <div class="fe-modal-search-box">
              <i class="fa-solid fa-magnifying-glass"></i>
              <input type="search" placeholder="Search executant by name or phone…"
                     [ngModel]="executantSearch()" (ngModelChange)="executantSearch.set($event)" />
            </div>
          </div>
        }

        <div class="fe-modal-body">
          @if (listShowsExecutants()) {
            @if (executantList().length === 0) {
              <div class="ex-no-data">
                <i class="fa-solid fa-user-slash" style="font-size:32px;display:block;margin-bottom:10px;color:#cbd5e1"></i>
                No executants found. Add executant info to projects via the Edit button in the GP table.
              </div>
            } @else {
              <table class="ex-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Executant Name</th>
                    <th class="text-center">Projects</th>
                    <th class="text-center">Completed</th>
                    <th class="text-center">Delayed</th>
                    <th class="text-center">Risk</th>
                  </tr>
                </thead>
                <tbody>
                  @for (e of executantList(); track e.key; let i = $index) {
                    <tr (click)="navigateToExecutant(e.key)">
                      <td style="color:#94a3b8;font-size:11px;width:36px">{{i+1}}</td>
                      <td>
                        <button class="ex-name-btn">
                          <i class="fa-solid fa-user-tie"></i>
                          {{e.name || '—'}}
                        </button>
                        @if (e.number) {
                          <div class="ex-phone"><i class="fa-solid fa-phone" style="font-size:9px;margin-right:4px"></i>{{e.number}}</div>
                        }
                      </td>
                      <td class="text-center" style="font-weight:800;color:#0f172a">{{e.total}}</td>
                      <td class="text-center" style="color:#15803d;font-weight:700">{{e.completed}}</td>
                      <td class="text-center" style="color:#dc2626;font-weight:700">{{e.delayed}}</td>
                      <td class="text-center">
                        <span class="ex-risk-pill" [class]="'risk-' + e.risk">{{e.riskLabel}}</span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          } @else if (listShowsBlocks()) {
            @if (listBlocks().length === 0) {
              <div class="fe-empty"><i class="fa-solid fa-circle-check"></i><p>No matching blocks.</p></div>
            } @else {
              <table class="fe-modal-table">
                <thead>
                  <tr>
                    <th>Block</th>
                    <th class="text-center">Projects</th>
                    <th class="text-center">On Track</th>
                    <th class="text-center">Delayed</th>
                    <th class="text-center">Avg. Progress</th>
                    <th class="text-right">Sanctioned (₹L)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (b of listBlocks(); track b.block) {
                    <tr (click)="selectBlock(b); closeList()">
                      <td>{{ blockLabel(b.block) }}</td>
                      <td class="text-center">{{ b.totalProjects }}</td>
                      <td class="text-center">{{ b.onTrackCount }} ({{ b.onTrackPercent }}%)</td>
                      <td class="text-center">{{ b.delayedCount }} ({{ b.delayedPercent }}%)</td>
                      <td class="text-center">{{ b.avgProgress }}%</td>
                      <td class="text-right">{{ formatCostLakh(b.sanctionedAmount) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          } @else {
            @if (listProjects().length === 0) {
              <div class="fe-empty"><i class="fa-solid fa-circle-check"></i><p>No matching projects.</p></div>
            } @else {
              <table class="fe-modal-table">
                <thead>
                  <tr>
                    <th>Project</th>
                    <th>Block / Village</th>
                    <th>Status</th>
                    <th class="text-center">Progress</th>
                    <th class="text-right">Cost (₹L)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (p of listProjects(); track p.id) {
                    <tr>
                      <td>{{ p.name }}</td>
                      <td>{{ p.block || p.dept || '–' }} / {{ p.village || p.loc || '–' }}</td>
                      <td>
                        <span class="status-pill"
                              [class.stuck]="p.status === 'Stuck'"
                              [class.completed]="p.status === 'Completed'"
                              [class.inprogress]="p.status === 'In Progress'"
                              [class.planned]="p.status === 'Planned'">{{ statusLabel(p.status) }}</span>
                      </td>
                      <td class="text-center">{{ p.physical || 0 }}%</td>
                      <td class="text-right">{{ p.cost | number }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          }
        </div>

        <div class="fe-modal-footer">
          <button class="fe-btn-cancel" (click)="closeList()">Close</button>
        </div>
      </div>
    </div>
  }

</div>
